import Model, { attr } from '@ember-data/model';

export default class EmployeeVisitMetrics extends Model {
  @attr('number', { defaultValue: 0 }) declare scheduled: number;
  @attr('number', { defaultValue: 0 }) declare signedIn: number;
  @attr('number', { defaultValue: 0 }) declare signedOut: number;

  get total(): number {
    const scheduledNum = Number(this.scheduled) || 0;
    const signedInNum = Number(this.signedIn) || 0;
    const signedOutNum = Number(this.signedOut) || 0;
    return scheduledNum + signedInNum + signedOutNum;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'employee-visit-metrics': EmployeeVisitMetrics;
  }
}
